import { DropShadow, Hex, Stroke } from '@acies/core';

const neutral0 = new Hex('#FFFFFF');
const neutral50 = new Hex('#F5F7FA');
const neutral100 = new Hex('#F0F1F5');
const neutral200 = new Hex('#E1E4EA');
const neutral300 = new Hex('#CACFD8');
const neutral400 = new Hex('#99A0AE');
// const neutral500 = new Hex('#717784');
const neutral600 = new Hex('#525866');
// const neutral700 = new Hex('#2B303B');
// const neutral800 = new Hex('#222530');
// const neutral900 = new Hex('#181B25');
const neutral950 = new Hex('#0E121B');

const red50 = new Hex('#FFEBEC');
const red500 = new Hex('#FB3748');
const red600 = new Hex('#E93544');

const sky50 = new Hex('#EBF8FF');
const sky500 = new Hex('#47C2FF');

const orange500 = new Hex('#FA7319');
const orange50 = new Hex('#FFF3EB');

const shadowLight = new Hex('#333333', 0.08);
const shadowMedium = new Hex('#333333', 0.16);

/**
 * The theme const / singleton directly maps its values to the Figma Design System file Variables.
 *
 * The out commented parts are unused values for now, but they will be included when needed.
 */
const theme = {
	colors: {
		error: {
			base: red500,
			lighter: red50,
		},
		fill: {
			focus: sky50,
			selected: neutral100,
			soft: neutral200,
			sub: neutral300,
			weak: neutral50,
			white: neutral0,
		},
		icon: {
			disabled: neutral300,
			error: red600,
			focused: sky500,
			soft: neutral400,
			strong: neutral950,
			sub: neutral600,
			warning: orange500,
			white: neutral0,
		},
		stroke: {
			focus: sky500,
			soft: neutral200,
		},
		text: {
			disabled: neutral300,
			error: red500,
			strong: neutral950,
			sub: neutral600,
			weak: neutral400,
			white: neutral0,
		},
		warning: {
			base: orange500,
			lighter: orange50,
		},
	},
	effects: {
		shadows: {
			light: new DropShadow(0, 5, 5, -2.5, shadowLight),
			medium: new DropShadow(0, 1, 3, -1.5, shadowMedium),
		},
	},
	strokes: {
		error: new Stroke(red500, 2, 'center'),
		focus: new Stroke(sky500, 2, 'center'),
		focus_inside: new Stroke(sky500, 2, 'inside'),
		soft: new Stroke(neutral200, 1, 'center'),
		sub: new Stroke(neutral300, 1, 'center'),
		warning: new Stroke(orange500, 2, 'center'),
		white: new Stroke(neutral0, 1, 'inside'),
	},
} as const;

export default theme;
